import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getWorkWiseAuthToken } from "./utils/auth";
import { workwiseServices } from "./api";
import { setDocumentInformation, setUserInformation, setIsAuthenticated } from '../src/app/EditorSlice';
import { useDispatch, useSelector } from "react-redux";
import Loader from "./components/SkeletonLoader/Loader";

export const AuthenticateDocument = ({ setIsLoading }) => {

  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);

  const handleAuhenticate = async () => {
    try {
      setIsLoading(true);
      if (!window.navigator.onLine) {
        // navigate('/no-internet');
        window.location.pathname = "/no-internet"
        return;
      }
      else {
        if (!!getWorkWiseAuthToken()) {
          const response = await workwiseServices.getDocumentById(id);
          if (response?.status == 200 && response.data?.data?.rightType !== 0 && response.data?.data) {
            setIsLoading(false);
            dispatch(setDocumentInformation(response.data.data));
            dispatch(setIsAuthenticated(true));
          }
          if (response.data?.data?.rightType == 0) {
            // navigate("/unauthorized")
            window.location.pathname = "/unauthorized"
          }
          // history.push("/unauthorized")
        }
        else {
          // navigate("/unauthorized")
          window.location.pathname = "/unauthorized"
        }
      }
    } catch (error) {
      console.log({ error })
      if (error.response?.data?.responseCode === 1008) {
        if (isTemplateDocument) {
          // For templates, 1008 is not a failure, set authenticated
          setIsLoading(false);
          dispatch(setIsAuthenticated(true));
          return;
        } else {
          // navigate("/invalid-document")
          window.location.pathname = "/invalid-document"
        }
      }
      else {
        // navigate("/unauthorized")
        window.location.pathname = "/unauthorized"

      }
    }
  }

  useEffect(() => {
    if (isTemplateDocument !== null) {
      handleAuhenticate();
    }
  }, [isTemplateDocument]);

  return <Loader />

}